"use strict";
const createSearchStringQuery = searchString => {
    if (!searchString || searchString.trim() === '') {
        return { and: [] };
    }
    const tokens = searchString.split(' ');
    return {
        and: [
            { isInventoryArticle: false },
            ...tokens.map(token => ({
                or: [
                    { name: { iLike: `%${token}%` } },
                    {
                        '$"defaultArticle"."articleNumber"$': {
                            iLike: `%${token}%`,
                        },
                    },
                    {
                        '$"defaultArticle"."shortName"$': {
                            iLike: `%${token}%`,
                        },
                    },
                    {
                        '$"defaultArticle"."shortDescription"$': {
                            iLike: `%${token}%`,
                        },
                    },
                    {
                        '$"defaultArticle"."productCategory"$': {
                            iLike: `%${token}%`,
                        },
                    },
                    {
                        '$"defaultArticle"."keywords"$': {
                            iLike: `%${token}%`,
                        },
                    },
                    {
                        '$"procurementList.name"$': {
                            iLike: `%${token}%`,
                        },
                    },
                ],
            })),
        ],
    };
};
module.exports = createSearchStringQuery;
